import * as Yup from 'yup';
import { useState, useEffect, useContext } from 'react';
import { useFormik, Form, FormikProvider } from 'formik';
import { useNavigate, useParams } from 'react-router-dom';
import { mask } from "remask";


// material
import { Stack, TextField, Alert, Autocomplete, MenuItem} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { ThemeProvider } from '@mui/material/styles';
import Theme from '../../../components/Button';

import {api, reiniciarToken, editarUsuario, visualizarUsuario, consEmpresa} from '../../../services/api';

// context
import { AuthContext } from '../../../contexts/auth';

import { fDateFormatCalendario } from '../../../utils/formatTime';

// ----------------------------------------------------------------------

export default function EditarUsuarioForm() {

  const {id} = useParams();
  const { logout } = useContext(AuthContext);
  const [empresa, setEmpresa] = useState('');
  const navigate = useNavigate();

  const [status, setStatus] = useState({
    type: '',
    mensagem: ''
  })

  const RegisterSchema = Yup.object().shape({
    usuario: Yup.string().required('Usuário é obrigatório'),
    email: Yup.string().email('Informe um email válido'),
    acesso_permitido: Yup.string().required('Permissão de acesso é obrigatório'),
    id_empresa: Yup.string().required('Empresa é obrigatório'),
    menu_restrito: Yup.string().required('Pefil é obrigatório'),
  });

  const formik = useFormik({
   initialValues: {
        usuario: '',
        email: '',
        acesso_permitido: '',
        id_empresa: '',
        menu_restrito: '',
    },
    validationSchema: RegisterSchema,
    onSubmit: () => {
      navigate('/dashboard', { replace: true });
    },
  });

  const [empresas, setListEmpresa] = useState([]);

  const getListas = async () => {

    const responseEmpresa = await consEmpresa();

    if(responseEmpresa.erro === true) {
      if (responseEmpresa.mensagem === 'O Token é inválido!' || responseEmpresa.mensagem === 'Acesso negado!'){
        logout();
      }
    }else {
      responseEmpresa.data.forEach((valores) => {
        setListEmpresa(empresas => [...empresas, {id_empresa: valores.id_empresa, descricao: valores.descricao}])
      }); 
    };
  }

  const handleSubmit = async e => {
    e.preventDefault();
    const response = await editarUsuario(id, formik.values);

    if(response.erro === true) {
      if (response.mensagem === 'O Token é inválido!' || response.mensagem === 'Acesso negado!'){
        logout();
      }else {
        setStatus({
          type: "erro",
          mensagem: response.mensagem
        })
      }
    }else {
      setStatus({
        type: "success",
        mensagem: response.data.mensagem
      })
    };
  }

  const { errors, touched, isSubmitting, getFieldProps, handleBlur, handleChange, setFieldValue} = formik;

  useEffect(() => {
    getListas();

    const getUsuarios = async () => {
      const retorno = await reiniciarToken();
      if(retorno.erro === true) {
        if (retorno.mensagem === 'O Token é inválido!' || retorno.mensagem === 'Acesso negado!'){
          logout();
        }
      }else{
        localStorage.setItem("token", retorno.data.token);
        api.defaults.headers.Authorization = `Bearer ${retorno.data.token}`;
      }
      
      const response = await visualizarUsuario(id);

      if(response.erro === true) {
        if (response.mensagem === 'O Token é inválido!' || response.mensagem === 'Acesso negado!'){
          logout();
        }else {
          setStatus({
            type: "erro",
            mensagem: response.mensagem
          })
        }
      };

      const campos = ['usuario', 'email', 'acesso_permitido', 'id_empresa', 'menu_restrito'];

      campos.forEach((campo) => {
        if (campo === 'id_empresa') {
          setFieldValue(campo, response.data[0][campo], false);
          setEmpresa({id_empresa: response.data[0][campo], descricao: response.data[0].empresa.descricao})

        }else{
          setFieldValue(campo, response.data[0][campo], false);
        }
      })
    }

    getUsuarios();

  } , [setFieldValue, id]);

  return (
    <FormikProvider value={formik}>
      <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
        <Stack spacing={3}>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
            <TextField 
              fullWidth
              label="Usuário"
              {...getFieldProps('usuario')}
              error={Boolean(touched.usuario && errors.usuario)}
              helperText={touched.usuario && errors.usuario}
            />
            <TextField 
              fullWidth
              label="E-mail"
              {...getFieldProps('email')}
              error={Boolean(touched.email && errors.email)}
              helperText={touched.email && errors.email}
            />
          </Stack>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
            <TextField 
              select
              fullWidth
              label="Permissão de Acesso"
              {...getFieldProps('acesso_permitido')}
              error={Boolean(touched.acesso_permitido && errors.acesso_permitido)}
              helperText={touched.acesso_permitido && errors.acesso_permitido}
            >
              <MenuItem value ="1">Liberado</MenuItem>
              <MenuItem value ="2">Sem Permissão</MenuItem> 
            </TextField>
            <TextField 
              select
              fullWidth
              label="Pefil Restrito"
              {...getFieldProps('menu_restrito')}
              error={Boolean(touched.menu_restrito && errors.menu_restrito)}
              helperText={touched.menu_restrito && errors.menu_restrito}
            >
              <MenuItem value ="1">Sim</MenuItem>
              <MenuItem value ="2">Não</MenuItem> 
            </TextField>
            <Autocomplete
                getOptionLabel={(resultado) => resultado.descricao || ""}
                options={empresas}
                fullWidth
                value={empresa}
                onChange={(e, value) => { 
                  setFieldValue('id_empresa', value?.id_empresa, false) 
                  setEmpresa({id_empresa: value?.id_empresa, descricao: value?.descricao})
                }}
                renderInput={(params) => (<TextField {...params} 
                                            label="Empresa" 
                                            fullWidth
                                            {...getFieldProps('id_empresa')}
                                            error={Boolean(touched.id_empresa && errors.id_empresa)}
                                            helperText={touched.id_empresa && errors.id_empresa}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={formik.values?.id_empresa}
                                            />
                                          )}
                isOptionEqualToValue={(option, value) => {
                  if (value === "" || value.id_empresa === option.id_empresa)
                      return true; 
                }}
            />
          </Stack>

          <Stack spacing={3}>
            {status.type === 'erro' ? <Alert severity="error">{status.mensagem}</Alert> : ""}
            {status.type === 'success' ? <Alert severity="success">{status.mensagem}</Alert> : ""}
          </Stack>

          <ThemeProvider theme={Theme}>
            <LoadingButton fullWidth size="large" type="submit" variant="contained" color="neutral" loading={isSubmitting}>
              Alterar
            </LoadingButton>
          </ThemeProvider>
        </Stack>  
      </Form>
    </FormikProvider>
  );
}
